
/**
 * @nullable
 */
export type PublishCourseDraft200Level = typeof PublishCourseDraft200Level[keyof typeof PublishCourseDraft200Level] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublishCourseDraft200Level = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
